import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { to: '/', label: 'Accueil' },
    { to: '/reparation', label: 'Réparation' },
    { to: '/peinture', label: 'Peinture' },
    { to: '/entretien', label: 'Entretien' },
    { to: '/prestations', label: 'Prestations' },
    { to: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <header className="header-fixed" data-testid="main-header">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center" data-testid="logo-link">
              <span 
                className="text-2xl md:text-3xl font-bold tracking-tight"
                style={{ fontFamily: 'Barlow Condensed, sans-serif', color: '#1a1a1a' }}
              >
                IDMAT<span style={{ color: '#F5C500' }}>SERVICE</span>
              </span>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`nav-link ${isActive(link.to) ? 'active' : ''}`}
                  data-testid={`nav-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* CTA Button & Phone */}
            <div className="hidden md:flex items-center gap-4">
              <a 
                href="tel:0693526449" 
                className="flex items-center gap-2 text-[#1a1a1a] hover:text-[#F5C500] transition-colors"
                data-testid="phone-link"
              >
                <Phone size={18} />
                <span className="font-semibold" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                  06 93 52 64 49
                </span>
              </a>
              <Link
                to="/contact"
                className="btn-primary"
                data-testid="header-cta"
              >
                Devis Gratuit
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden p-2"
              onClick={() => setMobileMenuOpen(true)}
              data-testid="mobile-menu-button"
              aria-label="Ouvrir le menu"
            >
              <Menu size={28} color="#1a1a1a" />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div 
        className={`mobile-menu-overlay ${mobileMenuOpen ? 'open' : ''}`}
        onClick={() => setMobileMenuOpen(false)}
      />

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`} data-testid="mobile-menu">
        <div className="p-6">
          <div className="flex items-center justify-between mb-8">
            <span 
              className="text-xl font-bold"
              style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
            >
              IDMAT<span style={{ color: '#F5C500' }}>SERVICE</span>
            </span>
            <button 
              onClick={() => setMobileMenuOpen(false)}
              aria-label="Fermer le menu"
              data-testid="close-mobile-menu"
            >
              <X size={24} />
            </button>
          </div>

          <nav className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-lg font-semibold py-2 ${isActive(link.to) ? 'text-[#F5C500]' : 'text-[#1a1a1a]'}`}
                style={{ fontFamily: 'Barlow Condensed, sans-serif', textTransform: 'uppercase' }}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="mt-8 pt-8 border-t border-gray-200">
            <a 
              href="tel:0693526449" 
              className="flex items-center gap-2 text-[#1a1a1a] mb-4"
              data-testid="mobile-phone-link"
            >
              <Phone size={20} />
              <span className="font-semibold">06 93 52 64 49</span>
            </a>
            <Link
              to="/contact"
              className="btn-primary block text-center"
              onClick={() => setMobileMenuOpen(false)}
              data-testid="mobile-cta"
            >
              Devis Gratuit
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
